import { useState, useEffect } from "react";
import { IntegrationStatus } from "@/types/integration";

/**
 * Hook to check if Financials or Dimensions modules are integrated
 * This would typically fetch from your backend/settings
 * For now, it uses localStorage for demo purposes
 */
export function useIntegrationStatus(): IntegrationStatus {
  const [status, setStatus] = useState<IntegrationStatus>({
    isFinancialsIntegrated: false,
    isDimensionsIntegrated: false,
    isAnyIntegrated: false,
  });

  useEffect(() => {
    // Check localStorage for integration settings
    // In production, this would be an API call to your backend
    const financialsEnabled = localStorage.getItem("integration.financials.enabled") === "true";
    const dimensionsEnabled = localStorage.getItem("integration.dimensions.enabled") === "true";

    setStatus({
      isFinancialsIntegrated: financialsEnabled,
      isDimensionsIntegrated: dimensionsEnabled,
      isAnyIntegrated: financialsEnabled || dimensionsEnabled,
    });
  }, []);

  return status;
}
